import TableCompHead from '../../../../../components/ui/TableCompHead';
import { useQuery } from '../../../../../hooks/UseQuery';

interface IProps {
  moduleData: any;
  isView: boolean;
}
const numberCol = Array.from({ length: 31 }, (_, index) => index + 1);
const theadData = [
  'Sr. No.',
  'Machine No',
  'Check Point',
  ...numberCol,
  'Delete',
];

const THead = ({ moduleData, isView }: IProps) => {
  const date = useQuery('annual_date');
  return (
    <thead>
      <TableCompHead
        colSpan={35}
        rowSpan={3}
        labels={['Doc No', 'Rev', 'Dated']}
        values={['FM/MAINT/06', '01', '04.05.2020']}
        heading="Daily Machine Safety Check Point & Monitoring( 1st Floor )"
      />
      <tr>
        <th colSpan={35} align="left">
          Month : {date}
        </th>
      </tr>
      <tr style={{ background: '#38d9a9' , height:"60px"}}>
        {theadData.map((heading, index) => (
          <th key={''+heading+index}>
            {heading}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default THead;
